
import Shape from '@/assets/svg/icons/shape-even.svg';
import gsap, { ScrollTrigger } from '~/plugins/gsap';
import throttle from 'lodash/throttle';
import Vue from 'vue';
import { TransformedCmTextImageHighlight } from '~/transforms/transformModules';

export default Vue.extend({
  components: {
    Shape,
  },
  data() {
    return {
      windowWidth: null as any,
      throttledResize: null as any,
    };
  },
  props: {
    data: {
      type: Object as () => TransformedCmTextImageHighlight['data'],
      required: true,
    },
  },

  mounted() {
    this.throttledResize = throttle(this.elementShiftEvent, 600);
    this.initResizeEvent();
    this.elementShiftEvent();
    this.initAnimation();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.throttledResize);
  },

  methods: {
    initAnimation() {
      if (!process.client) {
        return;
      }

      const imageWrapper = this.$el.querySelector<HTMLElement>('.cm-text-image-highlight__image-wrapper');
      const imageHero = this.$el.querySelector<HTMLElement>('.cm-text-image-highlight__image--hero');
      const imageSub = this.$el.querySelector<HTMLElement>('.cm-text-image-highlight__image--sub');

      // Check if module is within a layer ---> change scroller!
      let scroller = document.body;
      const parent = this.$el.parentElement as any;
      if (parent) {
        if (parent.classList.contains('cm-exp-layer__expanded-layer')) {
          scroller = parent;
        }
      }

      gsap.set([imageHero, imageSub], {
        clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)',
      });
      gsap.to([imageHero, imageSub], {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1,
        stagger: 0.2,
        ease: 'curveAppear',
        scrollTrigger: {
          scroller: scroller,
          trigger: imageWrapper,
          start: 'top 80%',
        },
      });

      const shape = this.$el.querySelector('.cm-text-image-highlight__image-shape') as HTMLElement;

      ScrollTrigger.saveStyles(shape);

      gsap.to(shape, { opacity: 1, duration: 1 });

      let mm = gsap.matchMedia();
      mm.add('(max-width: 767px)', () => {
        gsap.set(shape, { y: () => -shape.getBoundingClientRect().height / 3 });
        gsap.fromTo(
          shape,
          { y: () => -shape.getBoundingClientRect().height / 3, opacity: 1 },
          {
            y: () => shape.getBoundingClientRect().height / 3,
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              scroller: scroller,
              trigger: imageWrapper,
              start: 'center bottom',
              end: 'center top',
              scrub: 0.8,
              invalidateOnRefresh: true, // do update dynamic value!
            },
          }
        );
      });
      mm.add('(min-width: 768px)', () => {
        gsap.set(shape, { y: () => -shape.getBoundingClientRect().height / 2 });
        gsap.fromTo(
          shape,
          { y: () => -shape.getBoundingClientRect().height / 2, opacity: 1 },
          {
            y: 0,
            opacity: 1,
            ease: 'none',
            scrollTrigger: {
              scroller: scroller,
              trigger: imageWrapper,
              start: 'center bottom',
              end: 'center top',
              scrub: 0.8,
              invalidateOnRefresh: true, // do update dynamic value!
            },
          }
        );
      });
    },

    initResizeEvent() {
      window.addEventListener('resize', this.throttledResize);
    },

    elementShiftEvent() {
      const wrapperEl = this.$refs.wrapperEl as HTMLElement;
      const copyEl = this.$refs.copyEl as HTMLElement;
      const linkEl = this.$refs.linkEl as HTMLElement;
      const contentEl = this.$refs.contentEl as HTMLElement;
      const kickerEl = this.$refs.kickerEl as HTMLElement;
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 1024) {
        wrapperEl.append(copyEl);
        wrapperEl.append(linkEl);
      } else {
        contentEl.append(copyEl);
        kickerEl.append(linkEl);
      }
    },
  },
});
